import { render, staticRenderFns } from "./LendableBookInfo.vue?vue&type=template&id=c54b250a&scoped=true&"
import script from "./LendableBookInfo.vue?vue&type=script&lang=js&"
export * from "./LendableBookInfo.vue?vue&type=script&lang=js&"
import style0 from "./LendableBookInfo.vue?vue&type=style&index=0&id=c54b250a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54b250a",
  null
  
)

export default component.exports